/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Bookora API
 * API for **bookora.net** — multi-tenant SaaS for Iranian beauty clinics and
 * aesthetic doctors.
 *
 * ## Conventions
 *
 * - **Versioning**: customer-facing routes live under `/api/v1/...`. The health
 *   probes (`/health`, `/ready`) are unprefixed and version-neutral.
 * - **Response envelope**: every successful JSON response is
 *   `{ "data": <payload>, "meta"?: <extra> }`.
 * - **Error envelope**: every error response is
 *   `{ "statusCode": number, "code": string, "message": string, "details"?: any, "requestId"?: string }`.
 *   `code` is a stable token from `ErrorCode`; `message` is finished Persian copy.
 * - **Pagination**: list endpoints take 1-indexed `?page=&pageSize=` and return
 *   `{ items, page, pageSize, total, pageCount }` inside `data`.
 * - **Auth**: bearer JWT. Tokens come from `/api/v1/auth/otp/verify` and rotate on
 *   `/api/v1/auth/refresh`. There are no passwords in this product.
 * - **Tenancy**: the access token carries the clinic. Every tenant-scoped query is
 *   filtered by it server-side; a `clinicId` in a path or body must agree with the
 *   token or the request is rejected.
 * - **Currency**: every money field is an integer in **rials**. Panels display
 *   toman (1 toman = 10 rials).
 * - **Quantities**: integer milli-units (`…Milli`, 1 unit = 1000).
 *   **Percentages**: basis points (`…PercentBp`, 1% = 100).
 * - **Timestamps**: UTC ISO-8601. Jalali conversion happens in the UI.
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  CancelPatientPackageDto,
  ConsumeSessionDto,
  ConsumeSessionResponse,
  DeferredRevenueResponse,
  ExpireDueResponse,
  PatientPackageBalanceResponse,
  PatientPackageListResponse,
  PatientPackageResponse,
  PatientPackagesBalanceParams,
  PatientPackagesDeferredRevenueParams,
  PatientPackagesListParams,
  RefundPatientPackageDto,
  ReleaseSessionDto,
  SellPackageDto
} from '../model';

import { apiClient } from '../../mutator';




const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * به‌طور پیش‌فرض فقط پکیج‌های فعال. برای دیدن پکیج‌های تمام‌شده، منقضی، لغوشده و مستردشده includeClosed=true بفرستید.
 * @summary فهرست پکیج‌های فروخته‌شده
 */
export const patientPackagesList = (
    params?: PatientPackagesListParams,
 signal?: AbortSignal
) => {


      return apiClient<PatientPackageListResponse>(
      {url: `/api/v1/patient-packages`, method: 'GET',
        params, signal
    },
      );
    }




export const getPatientPackagesListQueryKey = (params?: PatientPackagesListParams,) => {
    return [
    `/api/v1/patient-packages`, ...(params ? [params] : [])
    ] as const;
    }


export const getPatientPackagesListQueryOptions = <TData = Awaited<ReturnType<typeof patientPackagesList>>, TError = void>(params?: PatientPackagesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientPackagesList>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPatientPackagesListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof patientPackagesList>>> = ({ signal }) => patientPackagesList(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof patientPackagesList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PatientPackagesListQueryResult = NonNullable<Awaited<ReturnType<typeof patientPackagesList>>>
export type PatientPackagesListQueryError = void


export function usePatientPackagesList<TData = Awaited<ReturnType<typeof patientPackagesList>>, TError = void>(
 params: undefined |  PatientPackagesListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientPackagesList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof patientPackagesList>>,
          TError,
          Awaited<ReturnType<typeof patientPackagesList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePatientPackagesList<TData = Awaited<ReturnType<typeof patientPackagesList>>, TError = void>(
 params?: PatientPackagesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientPackagesList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof patientPackagesList>>,
          TError,
          Awaited<ReturnType<typeof patientPackagesList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePatientPackagesList<TData = Awaited<ReturnType<typeof patientPackagesList>>, TError = void>(
 params?: PatientPackagesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientPackagesList>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary فهرست پکیج‌های فروخته‌شده
 */

export function usePatientPackagesList<TData = Awaited<ReturnType<typeof patientPackagesList>>, TError = void>(
 params?: PatientPackagesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientPackagesList>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPatientPackagesListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * یک نسخهٔ منجمد از پکیج (نام، خدمات، سقف‌ها و قیمت فهرست) در لحظهٔ فروش ذخیره می‌شود، پس تغییرات بعدی پکیج این فروش را دست نمی‌زند. pricePaidRials مبلغ واقعی توافق‌شده است و مبنای شناسایی درآمد؛ **در لحظهٔ فروش هیچ درآمدی شناسایی نمی‌شود.** اگر payment بفرستید، یک رسید پرداخت هم ثبت می‌شود (فقط ثبت، بدون درگاه).
 * @summary فروش پکیج به بیمار
 */
export const patientPackagesSell = (
    sellPackageDto: SellPackageDto,
 signal?: AbortSignal
) => {


      return apiClient<PatientPackageResponse>(
      {url: `/api/v1/patient-packages`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: sellPackageDto, signal
    },
      );
    }




export const getPatientPackagesSellMutationKey = () => ['patientPackagesSell'] as const;

export const getPatientPackagesSellMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patientPackagesSell>>, TError,PatientPackagesSellMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patientPackagesSell>>, TError,PatientPackagesSellMutationVariables, TContext> => {

const mutationKey = getPatientPackagesSellMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patientPackagesSell>>, PatientPackagesSellMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  patientPackagesSell(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PatientPackagesSellMutationResult = NonNullable<Awaited<ReturnType<typeof patientPackagesSell>>>
    export type PatientPackagesSellMutationBody = SellPackageDto
    export type PatientPackagesSellMutationError = void
    export type PatientPackagesSellMutationVariables = {data: SellPackageDto}

    /**
 * @summary فروش پکیج به بیمار
 */
export const usePatientPackagesSell = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patientPackagesSell>>, TError,PatientPackagesSellMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patientPackagesSell>>,
        TError,
        PatientPackagesSellMutationVariables,
        TContext
      > => {
      return useMutation(getPatientPackagesSellMutationOptions(options), queryClient);
    }
    /**
 * همان چیزی که پذیرش پیش از هر نوبت می‌پرسد: چند جلسه مانده، از کدام خدمت، و تا چه تاریخی. totalSessionsRemaining فقط پکیج‌های قابل استفاده را می‌شمارد؛ پکیج منقضی با جلسات استفاده‌نشده در این عدد نمی‌آید.
 * @summary مانده پکیج‌های یک بیمار
 */
export const patientPackagesBalance = (
    params: PatientPackagesBalanceParams,
 signal?: AbortSignal
) => {


      return apiClient<PatientPackageBalanceResponse>(
      {url: `/api/v1/patient-packages/balance`, method: 'GET',
        params, signal
    },
      );
    }




export const getPatientPackagesBalanceQueryKey = (params?: PatientPackagesBalanceParams,) => {
    return [
    `/api/v1/patient-packages/balance`, ...(params ? [params] : [])
    ] as const;
    }


export const getPatientPackagesBalanceQueryOptions = <TData = Awaited<ReturnType<typeof patientPackagesBalance>>, TError = void>(params: PatientPackagesBalanceParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientPackagesBalance>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPatientPackagesBalanceQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof patientPackagesBalance>>> = ({ signal }) => patientPackagesBalance(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof patientPackagesBalance>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PatientPackagesBalanceQueryResult = NonNullable<Awaited<ReturnType<typeof patientPackagesBalance>>>
export type PatientPackagesBalanceQueryError = void


export function usePatientPackagesBalance<TData = Awaited<ReturnType<typeof patientPackagesBalance>>, TError = void>(
 params: PatientPackagesBalanceParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientPackagesBalance>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof patientPackagesBalance>>,
          TError,
          Awaited<ReturnType<typeof patientPackagesBalance>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePatientPackagesBalance<TData = Awaited<ReturnType<typeof patientPackagesBalance>>, TError = void>(
 params: PatientPackagesBalanceParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientPackagesBalance>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof patientPackagesBalance>>,
          TError,
          Awaited<ReturnType<typeof patientPackagesBalance>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePatientPackagesBalance<TData = Awaited<ReturnType<typeof patientPackagesBalance>>, TError = void>(
 params: PatientPackagesBalanceParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientPackagesBalance>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary مانده پکیج‌های یک بیمار
 */

export function usePatientPackagesBalance<TData = Awaited<ReturnType<typeof patientPackagesBalance>>, TError = void>(
 params: PatientPackagesBalanceParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientPackagesBalance>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPatientPackagesBalanceQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * پولی که بابت پکیج‌ها دریافت شده ولی هنوز خدمتش ارائه نشده — یک **بدهی**، نه درآمد. رابطهٔ collectedRials − recognisedRials − refundedRials = deferredRials برای پکیج‌های فعال برقرار است. breakageRials سوخت پکیج‌های منقضی‌شده است که در تاریخ انقضا به درآمد تبدیل می‌شود.
 * @summary درآمد معوق پکیج‌ها
 */
export const patientPackagesDeferredRevenue = (
    params?: PatientPackagesDeferredRevenueParams,
 signal?: AbortSignal
) => {


      return apiClient<DeferredRevenueResponse>(
      {url: `/api/v1/patient-packages/deferred-revenue`, method: 'GET',
        params, signal
    },
      );
    }




export const getPatientPackagesDeferredRevenueQueryKey = (params?: PatientPackagesDeferredRevenueParams,) => {
    return [
    `/api/v1/patient-packages/deferred-revenue`, ...(params ? [params] : [])
    ] as const;
    }


export const getPatientPackagesDeferredRevenueQueryOptions = <TData = Awaited<ReturnType<typeof patientPackagesDeferredRevenue>>, TError = void>(params?: PatientPackagesDeferredRevenueParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientPackagesDeferredRevenue>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPatientPackagesDeferredRevenueQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof patientPackagesDeferredRevenue>>> = ({ signal }) => patientPackagesDeferredRevenue(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof patientPackagesDeferredRevenue>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PatientPackagesDeferredRevenueQueryResult = NonNullable<Awaited<ReturnType<typeof patientPackagesDeferredRevenue>>>
export type PatientPackagesDeferredRevenueQueryError = void


export function usePatientPackagesDeferredRevenue<TData = Awaited<ReturnType<typeof patientPackagesDeferredRevenue>>, TError = void>(
 params: undefined |  PatientPackagesDeferredRevenueParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientPackagesDeferredRevenue>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof patientPackagesDeferredRevenue>>,
          TError,
          Awaited<ReturnType<typeof patientPackagesDeferredRevenue>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePatientPackagesDeferredRevenue<TData = Awaited<ReturnType<typeof patientPackagesDeferredRevenue>>, TError = void>(
 params?: PatientPackagesDeferredRevenueParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientPackagesDeferredRevenue>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof patientPackagesDeferredRevenue>>,
          TError,
          Awaited<ReturnType<typeof patientPackagesDeferredRevenue>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePatientPackagesDeferredRevenue<TData = Awaited<ReturnType<typeof patientPackagesDeferredRevenue>>, TError = void>(
 params?: PatientPackagesDeferredRevenueParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientPackagesDeferredRevenue>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary درآمد معوق پکیج‌ها
 */

export function usePatientPackagesDeferredRevenue<TData = Awaited<ReturnType<typeof patientPackagesDeferredRevenue>>, TError = void>(
 params?: PatientPackagesDeferredRevenueParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientPackagesDeferredRevenue>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPatientPackagesDeferredRevenueQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * پکیج‌های فعالی را که تاریخ اعتبارشان گذشته به وضعیت «منقضی» می‌برد و سوخت آن‌ها را گزارش می‌کند. اجرای آن برای درستی کار لازم نیست — کسر جلسه از پکیج منقضی در هر حال رد می‌شود — ولی داشبورد مالی را با واقعیت هم‌تراز می‌کند.
 * @summary انقضای پکیج‌های سررسیدشده
 */
export const patientPackagesExpireDue = (

 signal?: AbortSignal
) => {


      return apiClient<ExpireDueResponse>(
      {url: `/api/v1/patient-packages/expire-due`, method: 'POST', signal
    },
      );
    }




export const getPatientPackagesExpireDueMutationKey = () => ['patientPackagesExpireDue'] as const;

export const getPatientPackagesExpireDueMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patientPackagesExpireDue>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patientPackagesExpireDue>>, TError,void, TContext> => {

const mutationKey = getPatientPackagesExpireDueMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patientPackagesExpireDue>>, void> = () => {


          return  patientPackagesExpireDue()
        }






  return  { mutationFn, ...mutationOptions }}

    export type PatientPackagesExpireDueMutationResult = NonNullable<Awaited<ReturnType<typeof patientPackagesExpireDue>>>

    export type PatientPackagesExpireDueMutationError = void


    /**
 * @summary انقضای پکیج‌های سررسیدشده
 */
export const usePatientPackagesExpireDue = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patientPackagesExpireDue>>, TError,void, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patientPackagesExpireDue>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getPatientPackagesExpireDueMutationOptions(options), queryClient);
    }
    /**
 * @summary جزئیات یک پکیج فروخته‌شده
 */
export const patientPackagesGetById = (
    id: string,
 signal?: AbortSignal
) => {


      return apiClient<PatientPackageResponse>(
      {url: `/api/v1/patient-packages/${id}`, method: 'GET', signal
    },
      );
    }




export const getPatientPackagesGetByIdQueryKey = (id: string,) => {
    return [
    `/api/v1/patient-packages/${id}`
    ] as const;
    }


export const getPatientPackagesGetByIdQueryOptions = <TData = Awaited<ReturnType<typeof patientPackagesGetById>>, TError = void>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientPackagesGetById>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPatientPackagesGetByIdQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof patientPackagesGetById>>> = ({ signal }) => patientPackagesGetById(id, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof patientPackagesGetById>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PatientPackagesGetByIdQueryResult = NonNullable<Awaited<ReturnType<typeof patientPackagesGetById>>>
export type PatientPackagesGetByIdQueryError = void


export function usePatientPackagesGetById<TData = Awaited<ReturnType<typeof patientPackagesGetById>>, TError = void>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientPackagesGetById>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof patientPackagesGetById>>,
          TError,
          Awaited<ReturnType<typeof patientPackagesGetById>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePatientPackagesGetById<TData = Awaited<ReturnType<typeof patientPackagesGetById>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientPackagesGetById>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof patientPackagesGetById>>,
          TError,
          Awaited<ReturnType<typeof patientPackagesGetById>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePatientPackagesGetById<TData = Awaited<ReturnType<typeof patientPackagesGetById>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientPackagesGetById>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary جزئیات یک پکیج فروخته‌شده
 */

export function usePatientPackagesGetById<TData = Awaited<ReturnType<typeof patientPackagesGetById>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientPackagesGetById>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPatientPackagesGetByIdQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * جلسهٔ انجام‌شده را به پکیج وصل و یک جلسه کسر می‌کند. **همین‌جاست که درآمد شناسایی می‌شود**: recognisedRials سهم درآمدی همین جلسه است و حسابداری آن را در تاریخ انجام جلسه ثبت می‌کند (نه Session.priceRials را، وگرنه دوبار شمرده می‌شود). فراخوانی دوباره برای همان جلسه بی‌اثر است و alreadyLinked=true برمی‌گرداند.
 * @summary کسر یک جلسه از پکیج
 */
export const patientPackagesConsume = (
    id: string,
    consumeSessionDto: ConsumeSessionDto,
 signal?: AbortSignal
) => {


      return apiClient<ConsumeSessionResponse>(
      {url: `/api/v1/patient-packages/${id}/consume`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: consumeSessionDto, signal
    },
      );
    }




export const getPatientPackagesConsumeMutationKey = () => ['patientPackagesConsume'] as const;

export const getPatientPackagesConsumeMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patientPackagesConsume>>, TError,PatientPackagesConsumeMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patientPackagesConsume>>, TError,PatientPackagesConsumeMutationVariables, TContext> => {

const mutationKey = getPatientPackagesConsumeMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patientPackagesConsume>>, PatientPackagesConsumeMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  patientPackagesConsume(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PatientPackagesConsumeMutationResult = NonNullable<Awaited<ReturnType<typeof patientPackagesConsume>>>
    export type PatientPackagesConsumeMutationBody = ConsumeSessionDto
    export type PatientPackagesConsumeMutationError = void
    export type PatientPackagesConsumeMutationVariables = {id: string;data: ConsumeSessionDto}

    /**
 * @summary کسر یک جلسه از پکیج
 */
export const usePatientPackagesConsume = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patientPackagesConsume>>, TError,PatientPackagesConsumeMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patientPackagesConsume>>,
        TError,
        PatientPackagesConsumeMutationVariables,
        TContext
      > => {
      return useMutation(getPatientPackagesConsumeMutationOptions(options), queryClient);
    }
    /**
 * جلسه را از پکیج جدا و شمارنده را یک واحد کم می‌کند — برای جلسه‌ای که لغو شده یا اشتباهی از این پکیج کسر شده است. درآمد شناسایی‌شده هم به همان نسبت برمی‌گردد.
 * @summary بازگرداندن یک جلسه به پکیج
 */
export const patientPackagesRelease = (
    id: string,
    releaseSessionDto: ReleaseSessionDto,
 signal?: AbortSignal
) => {


      return apiClient<PatientPackageResponse>(
      {url: `/api/v1/patient-packages/${id}/release`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: releaseSessionDto, signal
    },
      );
    }




export const getPatientPackagesReleaseMutationKey = () => ['patientPackagesRelease'] as const;

export const getPatientPackagesReleaseMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patientPackagesRelease>>, TError,PatientPackagesReleaseMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patientPackagesRelease>>, TError,PatientPackagesReleaseMutationVariables, TContext> => {

const mutationKey = getPatientPackagesReleaseMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patientPackagesRelease>>, PatientPackagesReleaseMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  patientPackagesRelease(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PatientPackagesReleaseMutationResult = NonNullable<Awaited<ReturnType<typeof patientPackagesRelease>>>
    export type PatientPackagesReleaseMutationBody = ReleaseSessionDto
    export type PatientPackagesReleaseMutationError = void
    export type PatientPackagesReleaseMutationVariables = {id: string;data: ReleaseSessionDto}

    /**
 * @summary بازگرداندن یک جلسه به پکیج
 */
export const usePatientPackagesRelease = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patientPackagesRelease>>, TError,PatientPackagesReleaseMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patientPackagesRelease>>,
        TError,
        PatientPackagesReleaseMutationVariables,
        TContext
      > => {
      return useMutation(getPatientPackagesReleaseMutationOptions(options), queryClient);
    }
    /**
 * پکیج بسته می‌شود و جلسات باقی‌مانده از بین می‌رود، بدون بازگرداندن پول. درآمد جلسات انجام‌شده شناسایی‌شده می‌ماند.
 * @summary لغو پکیج بدون استرداد
 */
export const patientPackagesCancel = (
    id: string,
    cancelPatientPackageDto: CancelPatientPackageDto,
 signal?: AbortSignal
) => {


      return apiClient<PatientPackageResponse>(
      {url: `/api/v1/patient-packages/${id}/cancel`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: cancelPatientPackageDto, signal
    },
      );
    }




export const getPatientPackagesCancelMutationKey = () => ['patientPackagesCancel'] as const;

export const getPatientPackagesCancelMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patientPackagesCancel>>, TError,PatientPackagesCancelMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patientPackagesCancel>>, TError,PatientPackagesCancelMutationVariables, TContext> => {

const mutationKey = getPatientPackagesCancelMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patientPackagesCancel>>, PatientPackagesCancelMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  patientPackagesCancel(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PatientPackagesCancelMutationResult = NonNullable<Awaited<ReturnType<typeof patientPackagesCancel>>>
    export type PatientPackagesCancelMutationBody = CancelPatientPackageDto
    export type PatientPackagesCancelMutationError = void
    export type PatientPackagesCancelMutationVariables = {id: string;data: CancelPatientPackageDto}

    /**
 * @summary لغو پکیج بدون استرداد
 */
export const usePatientPackagesCancel = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patientPackagesCancel>>, TError,PatientPackagesCancelMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patientPackagesCancel>>,
        TError,
        PatientPackagesCancelMutationVariables,
        TContext
      > => {
      return useMutation(getPatientPackagesCancelMutationOptions(options), queryClient);
    }
    /**
 * مبلغ پیش‌فرض، همان بخشی است که هنوز درآمد شناسایی‌نشده دارد (جلسات استفاده‌نشده، به قیمتی که واقعاً پرداخت شده). مبلغ بیشتر هم پذیرفته می‌شود ولی هرگز بیش از کل مبلغ پرداختی. استرداد به‌صورت یک رسید پرداخت با مبلغ **منفی** ثبت می‌شود تا گردش پول کامل بماند.
 * @summary استرداد پکیج
 */
export const patientPackagesRefund = (
    id: string,
    refundPatientPackageDto: RefundPatientPackageDto,
 signal?: AbortSignal
) => {


      return apiClient<PatientPackageResponse>(
      {url: `/api/v1/patient-packages/${id}/refund`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: refundPatientPackageDto, signal
    },
      );
    }




export const getPatientPackagesRefundMutationKey = () => ['patientPackagesRefund'] as const;

export const getPatientPackagesRefundMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patientPackagesRefund>>, TError,PatientPackagesRefundMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patientPackagesRefund>>, TError,PatientPackagesRefundMutationVariables, TContext> => {

const mutationKey = getPatientPackagesRefundMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patientPackagesRefund>>, PatientPackagesRefundMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  patientPackagesRefund(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PatientPackagesRefundMutationResult = NonNullable<Awaited<ReturnType<typeof patientPackagesRefund>>>
    export type PatientPackagesRefundMutationBody = RefundPatientPackageDto
    export type PatientPackagesRefundMutationError = void
    export type PatientPackagesRefundMutationVariables = {id: string;data: RefundPatientPackageDto}

    /**
 * @summary استرداد پکیج
 */
export const usePatientPackagesRefund = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patientPackagesRefund>>, TError,PatientPackagesRefundMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patientPackagesRefund>>,
        TError,
        PatientPackagesRefundMutationVariables,
        TContext
      > => {
      return useMutation(getPatientPackagesRefundMutationOptions(options), queryClient);
    }
